import React, {useMemo} from 'react';
import CLFBDetalleTabla from "../../sistema/sistemas/clfb/components/CLFBDetalleTabla";
import {QueryStatus} from "../../../types";
import LimitesCLFBAdicionales from "./LimitesCLFBAdicionales";
import {OperacionCLFBFields, OperacionCLFBLimitesAprobadosFields} from "../../sistema/sistemas/clfb/types/fields";
import CardLimite from "../CardLimite";
import {SistemaTipo} from "../../../types/enum/enum";
import {Card, Stack} from "@mui/material";
import {CLFBLimitesAprobadosPais} from "../../sistema/sistemas/clfb/types/types";
import {OperacionCLGFields, OperacionCLGLimitesAprobadosPaisFields} from "../../sistema/sistemas/clg/types/fields";

interface LimiteCLFBProps {
    data: CLFBLimitesAprobadosPais
}


function LimiteCLFB({data}: LimiteCLFBProps) {
    const agregadoAbsoluto = useMemo(() => {
        return data[OperacionCLFBFields.AgregadoAbsoluto]
    }, [data])
    const agregadoNeto = useMemo(() => {
        return data[OperacionCLFBFields.AgregadoNeto]
    }, [data])


    return (
        <Stack gap={1}>
            <CardLimite
                fechaAprobacion={data[OperacionCLGLimitesAprobadosPaisFields.FechaAlta]}
                fechaVencimiento={data[OperacionCLGLimitesAprobadosPaisFields.FechaAlta]}
                idMensaje={data[OperacionCLGLimitesAprobadosPaisFields.IdMensaje]}
                codSistema={SistemaTipo.CLFB}
                codPais={data[OperacionCLGFields.CodPais]}
                pais={data[OperacionCLGFields.NombrePais]}
            />

            <Card>
                <CLFBDetalleTabla
                    detalles={data[OperacionCLFBLimitesAprobadosFields.LimitList]}
                    codPais={-1}
                    permiteEditar={false} alGuardarDetalle={(d) => void 0}
                    isLoading={status === QueryStatus.Loading}
                    error={status === QueryStatus.Error}
                    adicionales={<LimitesCLFBAdicionales absoluto={agregadoAbsoluto} neto={agregadoNeto}/>}
                />
            </Card>
        </Stack>
    );
}

export default LimiteCLFB;